import Reflux from 'reflux';

const SdkUpdatesActions = Reflux.createActions(['load']);

export default SdkUpdatesActions;
